<!--
  Bloco da linha Tracking do painel "Status integrações" (Expedição) para o
  desfecho "XML do CT-e indisponível" (TMS-7192).

  Componente de APRESENTAÇÃO: recebe props, emite evento, não faz HTTP, não toca
  a área de transferência e não consulta permissão — a view continua dona de
  `$snotify` e do clipboard (mesma divisão de `OcorrenciaIntegracaoErro.vue`).

  Sem ação de reenvio, de propósito: a falha é determinística e reenviar repete o
  mesmo erro. O bloqueio autoritativo é do backend (`reenvio_permitido` = false /
  422) e o ícone de reenvio da carga já explica o motivo (TMS-8021).

  Todo valor do payload sai por interpolação `{{ }}` (texto escapado). Nunca por
  HTML cru: o harness reprova a diretiva de HTML bruto neste arquivo.
-->
<template>
  <div class="tracking-xml-cte-indisponivel mt-1">
    <strong class="d-block text-danger">{{ titulo }}</strong>

    <small class="d-block text-danger">{{ corpo }}</small>

    <div class="mt-1">
      <button
        type="button"
        class="btn btn-sm btn-primary mr-1 mb-1"
        @click="$emit('abrir-chamado', item)"
      >
        {{ acaoAbrirChamado }}
      </button>
    </div>

    <div v-if="detalhes.length > 0">
      <button
        type="button"
        class="btn btn-link btn-sm p-0"
        :aria-controls="collapseId"
        :aria-expanded="aberto ? 'true' : 'false'"
        @click="aberto = !aberto"
      >
        <i
          class="fa"
          :class="aberto ? 'fa-caret-down' : 'fa-caret-right'"
          aria-hidden="true"
        ></i>
        {{ rotuloDetalhes }}
      </button>
      <b-collapse :id="collapseId" v-model="aberto">
        <dl class="row mb-0 small text-muted">
          <template v-for="(detalhe, indice) in detalhes">
            <dt :key="`${collapseId}-rotulo-${indice}`" class="col-5">
              {{ detalhe.rotulo }}
            </dt>
            <dd :key="`${collapseId}-valor-${indice}`" class="col-7">
              {{ detalhe.valor }}
            </dd>
          </template>
        </dl>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import {
  ACAO_ABRIR_CHAMADO,
  CORPO,
  DETALHES_TECNICOS_TITULO,
  TITULO,
} from "../constants/xmlCteIndisponivelCopy";
import { detalhesTecnicos, idDetalhes } from "../utils/xmlCteIndisponivel";

export default {
  name: "TrackingXmlCteIndisponivel",

  props: {
    /** Item de `statusIntegracoes.statusTracking[]` com `tp_desfecho` de XML ausente. */
    item: {
      type: Object,
      required: true,
    },
    cargaId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      /** Recolhido por padrão, como a copy exige. */
      aberto: false,
      titulo: TITULO,
      corpo: CORPO,
      acaoAbrirChamado: ACAO_ABRIR_CHAMADO,
      rotuloDetalhes: DETALHES_TECNICOS_TITULO,
    };
  },

  computed: {
    detalhes() {
      return detalhesTecnicos(this.item, this.cargaId);
    },
    collapseId() {
      return idDetalhes(this.item, this.cargaId);
    },
  },
};
</script>
